/**
 * Versão React de lib/stageSemantics: lê as colunas da store e recalcula só
 * quando elas mudam. Separado da lib para a lib continuar pura (testável sem
 * o client do Supabase, que a store importa).
 */
import { useMemo } from 'react';
import { useStore } from '@/store/useStore';
import type { KanbanColumnDef } from '@/store/types';
import { buildStageSemantics, type StageSemantics } from '@/lib/stageSemantics';

export function useStageSemantics(columns?: KanbanColumnDef[]): StageSemantics {
  const storeColumns = useStore((s) => s.kanbanColumns);
  const cols = columns ?? storeColumns;
  return useMemo(() => buildStageSemantics(cols), [cols]);
}
